export const START_FETCH_ARTICLES = 'START_FETCH_ARTICLES';

export const SET_FETCHED_ARTICLES = 'SET_FETCHED_ARTICLES';

export const FETCH_ARTICLES_ERROR = 'FETCH_ARTICLES_ERROR';

export const START_FETCH_MORE_ARTICLES = 'START_FETCH_MORE_ARTICLES';

export const APPEND_FETCHED_ARTICLES = 'APPEND_FETCHED_ARTICLES';

export const FETCHED_NULL_ARTICLES = 'FETCHED_NULL_ARTICLES';

export const FETCHED_ARTICLE = 'FETCHED_ARTICLE';

export const START_FETCH_SINGLE_ARTICLE = 'START_FETCH_SINGLE_ARTICLE';

export const SET_FILTER = 'SET_FILTER';

export const UNSET_FILTER = 'UNSET_FILTER';

export const SET_ICS_TYPE = 'SET_ICS_TYPE';
